export enum InputfieldTypes {
  TEXT = "text",
  GOOGLE = "google",
  PASSWORD = "password",
  SELECT = "select",
  TEXT_AREA = "textarea",
  CHECKBOX = "checkbox",
  UPLOAD = "upload",
  LABEL = "label",
  OPTIONS_TABS = "optionTabs",
  SINGLE_OPTION_TAB = "singleOptionTab",
  MULTIPLE_SELECT = "multipleSelect",
  MULTIPLE_SELECT_SEARCH = "multipleSelectSearch",
  READONLY_TEXT = "readonly_text",
  NUMBER = "number",
  SWITCH = "switch",
  TIME_PICKER = "timePicker",
  DATE_PICKER = "datePicker",
  MARGINLESS_TEXT = "marginlessText",
  RANGE_PICKER = "rangePicker",
  SELECT_CUSTOM_FIELD = "selectCustomField",
  CONTROLLED_TEXT = "controlledText",
  ONCHANGE_TEXT = "onChangeText",
  TAG_SELECT = "tagSelect",
}

export enum InputFieldStatus {
  ERROR = "error",
}
